<app-header></app-header>
<app-authenticator [showAsRegistration]="true"></app-authenticator>
